import { render, staticRenderFns } from "./SingleChoiceSettings.vue?vue&type=template&id=3261db50&scoped=true"
import script from "./SingleChoiceSettings.vue?vue&type=script&lang=js"
export * from "./SingleChoiceSettings.vue?vue&type=script&lang=js"
import style0 from "./SingleChoiceSettings.vue?vue&type=style&index=0&id=3261db50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3261db50",
  null
  
)

export default component.exports